const initializedSections = new WeakSet();
const hintedSections = new WeakSet();
const mobileQuery = window.matchMedia('(max-width: 1034px)');
const closedText = 'APPLY FILTERS';
const openText = 'HIDE FILTERS';

const setToggleText = (toggle, text) => {
  const textEls = toggle.querySelectorAll('.btn__text');

  if (!textEls.length) {
    toggle.textContent = text;
    return;
  }

  textEls.forEach((textEl) => {
    textEl.textContent = text;
  });
};

const setPanelState = (section, toggle, panel) => {
  const isMobile = mobileQuery.matches;
  const isOpen = section.classList.contains('is-open-filters');

  if (!isMobile) {
    section.classList.remove('is-open-filters');
    toggle.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'false');
    setToggleText(toggle, closedText);
    return;
  }

  toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  setToggleText(toggle, isOpen ? openText : closedText);
};

const playInitialFiltersHint = (section) => {
  if (hintedSections.has(section) || !section.classList.contains('is-open-filters')) {
    return;
  }

  hintedSections.add(section);

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if (typeof window.playFiltersSwipeHints === 'function') {
        window.playFiltersSwipeHints(section, { force: true });
      }
    });
  });
};

const initVacanciesFilters = (scope = document) => {
  const sections = scope.querySelectorAll('.vacancies-sec');

  sections.forEach((section) => {
    if (initializedSections.has(section)) {
      return;
    }

    const toggle = section.querySelector('[data-vacancies-filters-toggle]');
    const panel = section.querySelector('[data-vacancies-filters-panel]');

    if (!toggle || !panel) {
      return;
    }

    initializedSections.add(section);

    const syncState = () => setPanelState(section, toggle, panel);

    toggle.addEventListener('click', () => {
      if (!mobileQuery.matches) {
        return;
      }

      section.classList.toggle('is-open-filters');
      syncState();
      playInitialFiltersHint(section);
    });

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', syncState);
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(syncState);
    }

    syncState();
  });
};

initVacanciesFilters();
window.initVacanciesFilters = initVacanciesFilters;
